export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      testimonials: 'Testimonials',
      contact: 'Contact',
      bookAppointment: 'Book Appointment'
    },
    
    // Hero Section
    hero: {
      title: 'Restore Balance.\nEmbrace Wellness.',
      subtitle: 'Experience the healing power of Traditional Chinese Medicine with personalized acupuncture, facial rejuvenation, and relaxation therapies designed for your well-being.',
      bookCTA: 'Book Your Appointment',
      exploreCTA: 'Explore Services'
    },
    
    // Services Section
    services: {
      title: 'Our Services',
      subtitle: 'Discover our range of Traditional Chinese Medicine treatments designed to restore balance and promote natural healing.',
      learnMore: 'Learn More',
      acupuncture: {
        name: 'Acupuncture',
        shortDesc: 'Traditional Chinese medicine technique using fine needles to restore balance and promote natural healing.',
        fullDesc: 'Our acupuncture treatments address a wide range of conditions including pain management, stress relief, digestive issues, and overall wellness. Each session is tailored to your specific needs.',
        benefits: [
          'Pain relief and management',
          'Stress and anxiety reduction',
          'Improved sleep quality',
          'Enhanced immune function',
          'Digestive health support'
        ]
      },
      aculifting: {
        name: 'Acu-lifting',
        shortDesc: 'Natural facial rejuvenation using massage and acupuncture techniques to enhance skin tone and reduce signs of aging.',
        fullDesc: 'Acu-lifting is a natural, non-invasive alternative to cosmetic procedures. By stimulating collagen production and improving circulation, this treatment helps reduce fine lines, improve skin tone, and restore a youthful glow.',
        benefits: [
          'Reduces fine lines and wrinkles',
          'Improves skin elasticity',
          'Enhances facial muscle tone',
          'Promotes natural collagen production',
          'Creates a healthy, radiant glow'
        ]
      },
      koreanRelaxation: {
        name: 'Korean Relaxation',
        shortDesc: 'Therapeutic approach combining traditional Korean techniques with acupuncture points stimulation through acupressure.',
        fullDesc: 'Experience deep relaxation and healing with our Korean relaxation therapy. This gentle yet effective treatment combines traditional Korean massage techniques with acupressure to release tension and restore balance.',
        benefits: [
          'Deep muscle relaxation',
          'Stress and tension relief',
          'Improved circulation',
          'Enhanced energy flow',
          'Mental clarity and calm'
        ]
      }
    },
    
    // Service Detail Pages
    serviceDetails: {
      duration: 'Duration',
      aboutTreatment: 'About This Treatment',
      therapeuticIndications: 'Therapeutic Indications:',
      benefits: 'Benefits:',
      whatToExpect: 'What to Expect',
      readyToBook: 'Ready to Book Your Appointment?',
      bookingCTA: 'Take the first step towards better health and wellness. Schedule your',
      sessionToday: 'session today.',
      
      acupuncture: {
        aboutText: 'Our acupuncture treatments address a wide range of conditions including pain management, stress relief, digestive issues, and overall wellness. Each session is tailored to your specific needs.',
        indications: [
          'Chronic pain: lower back pain, headaches, osteoarthritis, etc.',
          'Stress, anxiety, chronic insomnia',
          'Digestive problems, nausea, gastritis, etc.',
          'Sports related issues: sciatica, tennis/golfer\'s elbow, shoulder/knee pain, etc.',
          'Side effects of long term medication'
        ],
        expectSteps: [
          { title: 'Initial Consultation:', desc: 'We\'ll discuss your health concerns and treatment goals' },
          { title: 'Needle Placement:', desc: 'Fine, sterile needles are gently inserted at specific points' },
          { title: 'Relaxation:', desc: 'Rest comfortably for 15-20 minutes while the treatment works' },
          { title: 'Follow-up:', desc: 'Discuss your experience and plan next steps' }
        ],
        expectIntro: 'During your acupuncture session, you\'ll experience:'
      },
      
      aculifting: {
        aboutText: 'Acu-lifting is a natural, non-invasive alternative to cosmetic procedures. By stimulating collagen production and improving circulation, this treatment helps reduce fine lines, improve skin tone, and restore a youthful glow.',
        benefitsList: [
          'Reduces fine lines and wrinkles',
          'Improves skin elasticity',
          'Enhances facial muscle tone',
          'Promotes natural collagen production',
          'Creates a healthy, radiant glow'
        ],
        expectSteps: [
          { title: 'Facial Assessment:', desc: 'Analysis of your skin concerns and facial structure' },
          { title: 'Facial Massage:', desc: 'Gentle massage to prepare the skin and improve circulation' },
          { title: 'Acupuncture Treatment:', desc: 'Strategic needle placement on facial points' },
          { title: 'Aftercare Advice:', desc: 'Tips to maintain and enhance your results' }
        ],
        expectIntro: 'During your acu-lifting session, you\'ll experience:'
      },
      
      koreanRelaxation: {
        aboutText: 'Experience deep relaxation and healing with our Korean relaxation therapy. This gentle yet effective treatment combines traditional Korean techniques with acupressure to release tension and restore balance.',
        benefitsList: [
          'Deep muscle relaxation',
          'Stress and tension relief',
          'Improved circulation',
          'Enhanced energy flow',
          'Mental clarity and calm'
        ],
        expectSteps: [
          { title: 'Comfort Setup:', desc: 'Get comfortable in a peaceful, calming environment' },
          { title: 'Traditional Techniques:', desc: 'Experience authentic Korean massage methods' },
          { title: 'Acupressure:', desc: 'Targeted pressure points to release tension' },
          { title: 'Complete Relaxation:', desc: 'Leave feeling refreshed and balanced' }
        ],
        expectIntro: 'During your Korean relaxation session, you\'ll experience:'
      }
    },
    
    // About Section
    about: {
      title: 'Meet Your Practitioner',
      subtitle: 'Dedicated to your health and wellness through Traditional Chinese Medicine',
      name: 'Jeremy de Sainte Marie',
      practitionerTitle: 'Certified Acupuncturist & Traditional Chinese Medicine Practitioner',
      bio: 'With nearly 10 years of experience in Traditional Chinese Medicine, Jeremy is dedicated to helping patients achieve optimal health through natural, holistic approaches. He combines ancient wisdom with modern techniques to provide personalized care for each individual.',
      credentialsTitle: 'Credentials',
      credentials: [
        'Certified practitioner of Traditional Chinese Medicine - 5 years Certificate - IMTC and EMC Institutes',
        'DNMTC - French National Certificate'
      ]
    },
    
    // Testimonials Section
    testimonials: {
      title: 'What Our Patients Say',
      subtitle: 'Read about the experiences of those who have found healing and wellness with us',
      items: [
        {
          text: 'After struggling with chronic pain for years, Dr. Chen\'s acupuncture treatments have been life-changing. I finally feel like myself again!',
          name: 'Jennifer M.',
          service: 'Acupuncture'
        },
        {
          text: 'The acu-lifting treatments have given me visible results without any invasive procedures. My skin looks and feels amazing!',
          name: 'Michael T.',
          service: 'Acu-lifting'
        },
        {
          text: 'The Korean relaxation therapy is the perfect way to unwind after a stressful week. Dr. Chen creates such a peaceful, healing environment.',
          name: 'Lisa K.',
          service: 'Korean Relaxation'
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: 'Book Your Appointment',
      subtitle: 'Select your preferred service, date, and time. We look forward to supporting your wellness journey.',
      form: {
        selectService: 'Select Service',
        chooseService: 'Choose a service',
        firstConsultation: 'This is my first consultation (additional intake form required)',
        fullName: 'Full Name',
        email: 'Email',
        phone: 'Phone Number',
        reasonForConsultation: 'Reason for Consultation',
        reasonPlaceholder: 'Please describe your primary concern or reason for seeking acupuncture treatment...',
        selectDate: 'Select Date',
        selectTime: 'Select Time Slot',
        homeCare: 'Home Care',
        homeCareInfo: 'Available on Saturdays, additional fees may apply depending on the location. Contact me via WhatsApp or email for more informations',
        continueToIntake: 'Continue to Intake Form',
        confirmAppointment: 'Confirm Appointment',
        namePlaceholder: 'John Doe',
        emailPlaceholder: 'john@example.com',
        phonePlaceholder: '(555) 123-4567'
      },
      messages: {
        selectDateTime: 'Please select a date, time, and service',
        bookingSuccess: 'Appointment booked successfully! We will send you a confirmation email shortly.',
        consultationSuccess: 'First consultation form submitted successfully! We will contact you shortly.',
        slotConflict: 'This time slot was just booked by someone else. Please choose another.'
      }
    },
    
    // First Consultation Form
    consultation: {
      title: 'First Consultation Intake Form',
      patientInfo: 'Patient Information',
      majorComplaint: 'Major Complaint',
      medicalHistory: 'Past Medical History',
      conditionsSurgeries: 'Medical Conditions & Surgeries',
      allergies: 'Allergies',
      occupational: 'Occupational Concerns',
      medications: 'Current Medications',
      lifestyle: 'Lifestyle',
      femalesOnly: 'Female Health Information',
      
      fields: {
        dob: 'Date of Birth',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        maritalStatus: 'Marital Status',
        single: 'Single',
        married: 'Married',
        divorced: 'Divorced',
        homeAddress: 'Home Address',
        phoneHome: 'Home Phone',
        phoneCell: 'Cell Phone',
        occupation: 'Occupation',
        primaryDoctor: 'Primary Care Doctor',
        specialty: 'Specialty',
        emergencyContact: 'Emergency Contact Name',
        emergencyPhone: 'Emergency Contact Phone',
        insurance: 'Insurance Company',
        policyNumber: 'Policy Number',
        
        complaintDesc: 'Please describe your main concern',
        severity: 'Severity',
        severe: 'Severe',
        moderate: 'Moderate',
        slight: 'Slight',
        
        selectAll: 'Select all that apply:',
        year: 'Year',
        condition: 'Condition / Surgery',
        allergiesDesc: 'Medication, Seasonal, Food, Environmental',
        
        stress: 'Stress',
        heavyTyping: 'Heavy Typing/Computer Use',
        hazardous: 'Hazardous Substances',
        heavyLifting: 'Heavy Lifting',
        otherSpecify: 'Please specify',
        
        prescriptionName: 'Prescription Name',
        purpose: 'Purpose',
        howLong: 'How Long',
        dose: 'Dose / How often',
        lastDose: 'Last Dose',
        
        tobacco: 'Tobacco Use',
        alcohol: 'Alcohol Use',
        exercise: 'Exercise Frequency',
        yes: 'Yes',
        no: 'No',
        regular: 'Regular',
        occasional: 'Occasional',
        none: 'None',
        
        pregnant: 'Currently Pregnant',
        lastPeriod: 'Last Period',
        numPregnancies: 'Number of Pregnancies',
        numMiscarriages: 'Number of Miscarriages',
        birthControl: 'Form of Birth Control',
        menstrualCycle: 'Menstrual Cycle Details',
        pms: 'PMS (Premenstrual Syndrome)',
        menopause: 'Menopause Symptoms',
        
        cancellationPolicy: 'Cancellation Policy: I acknowledge that I will give at least 24 hour notice of cancellation to avoid a charge for the session. This is a courtesy to other patients who may need that appointment time. I will call if I anticipate being more than 10 minutes late for my appointment.',
        
        addCondition: '+ Add Another Condition',
        addMedication: '+ Add Another Medication',
        cancel: 'Cancel',
        submit: 'Submit Consultation Form'
      }
    },
    

    // Contact Section
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with us. We\'re here to answer your questions and help you on your wellness journey.',
      getInTouch: 'Get In Touch',
      address: 'Address',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      officeHours: 'Office Hours',
      hoursWeekday: 'Monday - Friday:',
      hoursWeekdayTime: '10:00 AM - 5:00 PM',
      hoursWeekend: 'Saturday & Sunday:',
      hoursWeekendTime: 'Closed',
      mapTitle: 'Find Us'
    },


    // First Consultation Form
    firstConsultation: {
      title: 'First Consultation Intake Form',
      subtitle: 'Please complete this form to help us provide you with the best care. You don\'t have to answer ALL questions, but doing so helps reduce time spent on the first consultation.',
      patientInfo: {
        title: 'Patient Information',
        dob: 'Date of Birth',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        maritalStatus: 'Marital Status',
        single: 'Single',
        married: 'Married',
        divorced: 'Divorced',
        homeAddress: 'Home Address',
        phoneHome: 'Home Phone',
        phoneCell: 'Cell Phone',
        occupation: 'Occupation'
      },
      majorComplaint: {
        title: 'Major Complaint',
        describe: 'Please describe your main concern',
        intensity: 'Intensity',
        severe: 'Severe',
        moderate: 'Moderate',
        slight: 'Slight'
      },
      pastMedicalHistory: {
        title: 'Past Medical History',
        checkAll: 'Check all that apply',
        options: {
          'AIDS': 'AIDS',
          'Anxiety Attacks': 'Anxiety Attacks',
          'Asthma': 'Asthma',
          'Autoimmune Disease': 'Autoimmune Disease',
          'Birth Defects': 'Birth Defects',
          'Bladder Infections': 'Bladder Infections',
          'Blood Disorders': 'Blood Disorders',
          'Breast Tumor or Cancer': 'Breast Tumor or Cancer',
          'Bronchitis': 'Bronchitis',
          'Cancer': 'Cancer',
          'Cirrhosis': 'Cirrhosis',
          'Connective Tissue Disorders': 'Connective Tissue Disorders',
          'Diabetes': 'Diabetes',
          'Epilepsy': 'Epilepsy',
          'Gallstones': 'Gallstones',
          'Gastric/Duodenal Ulcers': 'Gastric/Duodenal Ulcers',
          'German Measles': 'German Measles',
          'Heart Attack': 'Heart Attack',
          'Heart Disease': 'Heart Disease',
          'Heart Murmur': 'Heart Murmur',
          'Hepatitis': 'Hepatitis',
          'High Blood Pressure': 'High Blood Pressure',
          'Intestinal Bleeding': 'Intestinal Bleeding',
          'Kidney Infection': 'Kidney Infection',
          'Kidney Stones': 'Kidney Stones',
          'Lupus': 'Lupus',
          'Neurologic Disorders': 'Neurologic Disorders',
          'Panic Attack': 'Panic Attack',
          'Paralysis': 'Paralysis',
          'Rheumatoid Arthritis': 'Rheumatoid Arthritis',
          'Seizures': 'Seizures',
          'Thyroid Problems': 'Thyroid Problems',
          'Tuberculosis': 'Tuberculosis',
          'Varicose Veins': 'Varicose Veins'
        }
      },
      medicalConditions: {
        title: 'Medical Conditions & Surgeries',
        addCondition: '+ Add Another Condition',
        year: 'Year',
        yearPlaceholder: '2020',
        description: 'Description',
        descriptionPlaceholder: 'Describe condition or surgery'
      },
      allergies: {
        title: 'Allergies',
        label: 'Medication, Seasonal, Food, Environmental',
        placeholder: 'List any allergies...'
      },
      occupationalConcerns: {
        title: 'Occupational Concerns',
        specify: 'Please specify',
        options: {
          'Stress': 'Stress',
          'Heavy Typing/Computer Use': 'Heavy Typing/Computer Use',
          'Hazardous Substances': 'Hazardous Substances',
          'Heavy Lifting': 'Heavy Lifting',
          'Other': 'Other'
        }
      },
      currentMedications: {
        title: 'Current Medications',
        addMedication: '+ Add Another Medication',
        name: 'Medication name',
        purpose: 'What is it for?',
        duration: 'How long?',
        durationPlaceholder: '6 months',
        dosage: 'Dosage',
        dosagePlaceholder: '10mg daily',
        lastDose: 'Last Dose'
      },
      lifestyle: {
        title: 'Lifestyle',
        tobacco: 'Do you use tobacco?',
        alcohol: 'Do you drink alcohol?',
        exercise: 'Exercise',
        yes: 'Yes',
        no: 'No',
        regular: 'Regular',
        occasional: 'Occasional',
        none: 'None'
      },
      femaleHealth: {
        title: 'Female Health Information',
        pregnant: 'Are you pregnant?',
        lastPeriod: 'Last Period',
        numPregnancies: 'Number of Pregnancies',
        numMiscarriages: 'Number of Miscarriages',
        birthControl: 'Form of Birth Control',
        menstrualCycle: 'Menstrual Cycle Details',
        pms: 'PMS symptoms?',
        lastPapTest: 'Last PAP Test',
        ageStoppedPeriods: 'Age Stopped Periods',
        ageStoppedPlaceholder: 'If applicable',
        menopauseSymptoms: 'Menopause Symptoms',
        menopausePlaceholder: 'If applicable, describe any menopause symptoms'
      },
      buttons: {
        cancel: 'Cancel',
        submit: 'Submit Form'
      }
    },

    // Footer
    footer: {
      tagline: 'Traditional Chinese Medicine and holistic wellness services dedicated to your health and balance.',
      contact: 'Contact Us',
      hours: 'Office Hours',
      mondayFriday: 'Monday - Friday',
      saturday: 'Saturday',
      sundayClosed: 'Sunday - Closed',
      copyright: '© {year} Tranquil Acupuncture. All rights reserved.'
    },
    
    // Common
    common: {
      minutes: 'minutes',
      benefits: 'Benefits:',
      required: '*'
    }
  },
  
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      services: 'Services',
      about: 'À Propos',
      testimonials: 'Témoignages',
      contact: 'Contact',
      bookAppointment: 'Prendre Rendez-vous'
    },
    
    // Hero Section
    hero: {
      title: 'Restaurez l\'équilibre\nRetrouvez le bien-être',
      subtitle: 'Découvrez le pouvoir guérisseur de la Médecine Traditionnelle Chinoise avec l\'acupuncture personnalisée, le rajeunissement facial et les thérapies de relaxation conçues pour votre bien-être.',
      bookCTA: 'Réserver Votre Rendez-vous',
      exploreCTA: 'Découvrir les Services'
    },
    
    // Services Section
    services: {
      title: 'Nos Services',
      subtitle: 'Découvrez notre gamme de traitements de Médecine Traditionnelle Chinoise conçus pour restaurer l\'équilibre et promouvoir la guérison naturelle.',
      learnMore: 'En savoir plus',
      acupuncture: {
        name: 'Acupuncture',
        shortDesc: 'Technique de médecine traditionnelle chinoise utilisant de fines aiguilles pour restaurer l\'équilibre et favoriser la guérison naturelle.',
        fullDesc: 'Nos traitements d\'acupuncture traitent un large éventail de conditions, y compris la gestion de la douleur, le soulagement du stress, les problèmes digestifs et le bien-être général. Chaque séance est adaptée à vos besoins spécifiques.',
        benefits: [
          'Soulagement et gestion de la douleur',
          'Réduction du stress et de l\'anxiété',
          'Amélioration de la qualité du sommeil',
          'Renforcement du système immunitaire',
          'Soutien de la santé digestive'
        ]
      },
      aculifting: {
        name: 'Acu-lifting',
        shortDesc: 'Rajeunissement facial naturel utilisant des techniques de massage et d\'acupuncture pour améliorer le teint et réduire les signes du vieillissement.',
        fullDesc: 'L\'acu-lifting est une alternative naturelle et non invasive aux procédures cosmétiques. En stimulant la production de collagène et en améliorant la circulation, ce traitement aide à réduire les ridules, améliorer le teint et restaurer un éclat jeune.',
        benefits: [
          'Réduit les rides et ridules',
          'Améliore l\'élasticité de la peau',
          'Renforce le tonus musculaire facial',
          'Favorise la production naturelle de collagène',
          'Crée un éclat sain et radieux'
        ]
      },
      koreanRelaxation: {
        name: 'Relaxation Coréenne',
        shortDesc: 'Approche thérapeutique combinant les techniques coréennes traditionnelles avec la stimulation des points d\'acupuncture par acupression.',
        fullDesc: 'Découvrez une relaxation profonde et une guérison avec notre thérapie de relaxation coréenne. Ce traitement doux mais efficace combine des techniques de massage coréen traditionnelles avec l\'acupression pour libérer les tensions et restaurer l\'équilibre.',
        benefits: [
          'Relaxation musculaire profonde',
          'Soulagement du stress et des tensions',
          'Amélioration de la circulation',
          'Flux d\'énergie amélioré',
          'Clarté mentale et calme'
        ]
      }
    },
    
    
    // Service Detail Pages
    serviceDetails: {
      duration: 'Durée',
      aboutTreatment: 'À propos de ce traitement',
      therapeuticIndications: 'Indications thérapeutiques:',
      benefits: 'Avantages:',
      whatToExpect: 'À quoi s\'attendre',
      readyToBook: 'Prêt à réserver votre rendez-vous?',
      bookingCTA: 'Faites le premier pas vers une meilleure santé et bien-être. Planifiez votre séance d\'',
      sessionToday: 'aujourd\'hui.',
      
      acupuncture: {
        aboutText: 'Nos traitements d\'acupuncture traitent un large éventail de conditions, y compris la gestion de la douleur, le soulagement du stress, les problèmes digestifs et le bien-être général. Chaque séance est adaptée à vos besoins spécifiques.',
        indications: [
          'Douleur chronique: lombalgie, maux de tête, arthrose, etc.',
          'Stress, anxiété, insomnie chronique',
          'Problèmes digestifs, nausées, gastrite, etc.',
          'Problèmes liés au sport: sciatique, tennis/golf elbow, douleurs à l\'épaule/genou, etc.',
          'Effets secondaires de médicaments à long terme'
        ],
        expectSteps: [
          { title: 'Consultation initiale:', desc: 'Nous discuterons de vos préoccupations de santé et de vos objectifs de traitement' },
          { title: 'Placement des aiguilles:', desc: 'De fines aiguilles stériles sont doucement insérées à des points spécifiques' },
          { title: 'Relaxation:', desc: 'Reposez-vous confortablement pendant 15-20 minutes pendant que le traitement agit' },
          { title: 'Suivi:', desc: 'Discutez de votre expérience et planifiez les prochaines étapes' }
        ],
        expectIntro: 'Pendant votre séance d\'acupuncture, vous vivrez:'
      },
      
      aculifting: {
        aboutText: 'L\'acu-lifting est une alternative naturelle et non invasive aux procédures cosmétiques. En stimulant la production de collagène et en améliorant la circulation, ce traitement aide à réduire les ridules, améliorer le teint et restaurer un éclat jeune.',
        benefitsList: [
          'Réduit les rides et ridules',
          'Améliore l\'élasticité de la peau',
          'Renforce le tonus musculaire facial',
          'Favorise la production naturelle de collagène',
          'Crée un éclat sain et radieux'
        ],
        expectSteps: [
          { title: 'Évaluation faciale:', desc: 'Analyse de vos préoccupations cutanées et de votre structure faciale' },
          { title: 'Massage facial:', desc: 'Massage doux pour préparer la peau et améliorer la circulation' },
          { title: 'Traitement d\'acupuncture:', desc: 'Placement stratégique d\'aiguilles sur les points faciaux' },
          { title: 'Conseils après-soins:', desc: 'Conseils pour maintenir et améliorer vos résultats' }
        ],
        expectIntro: 'Pendant votre séance d\'acu-lifting, vous vivrez:'
      },
      
      koreanRelaxation: {
        aboutText: 'Découvrez une relaxation profonde et une guérison avec notre thérapie de relaxation coréenne. Ce traitement doux mais efficace combine des techniques coréennes traditionnelles avec l\'acupression pour libérer les tensions et restaurer l\'équilibre.',
        benefitsList: [
          'Relaxation musculaire profonde',
          'Soulagement du stress et des tensions',
          'Amélioration de la circulation',
          'Flux d\'énergie amélioré',
          'Clarté mentale et calme'
        ],
        expectSteps: [
          { title: 'Installation confortable:', desc: 'Installez-vous confortablement dans un environnement paisible et apaisant' },
          { title: 'Techniques traditionnelles:', desc: 'Découvrez les méthodes de massage coréen authentiques' },
          { title: 'Acupression:', desc: 'Points de pression ciblés pour libérer les tensions' },
          { title: 'Relaxation complète:', desc: 'Repartez en vous sentant rafraîchi et équilibré' }
        ],
        expectIntro: 'Pendant votre séance de relaxation coréenne, vous vivrez:'
      }
    },

    // About Section
    about: {
      title: 'Rencontrez votre praticien',
      subtitle: 'Dédié à votre santé et bien-être par la médecine traditionnelle chinoise',
      name: 'Jeremy de Sainte Marie',
      practitionerTitle: 'Acupuncteur certifié et praticien de médecine traditionnelle chinoise',
      bio: 'Avec près de 10 ans d\'expérience en médecine traditionnelle chinoise, Jeremy se consacre à aider les patients à atteindre une santé optimale grâce à des approches naturelles et holistiques. Il combine la sagesse ancienne avec des techniques modernes pour fournir des soins personnalisés à chaque individu.',
      credentialsTitle: 'Qualifications',
      credentials: [
        'Praticien certifié de médecine traditionnelle chinoise - Certificat de 5 ans - Instituts IMTC et EMC',
        'DNMTC - Diplôme national français'
      ]
    },
    
    // Testimonials Section
    testimonials: {
      title: 'Ce Que Disent Nos Patients',
      subtitle: 'Lisez les expériences de ceux qui ont trouvé la guérison et le bien-être avec nous',
      items: [
        {
          text: 'Après avoir lutté contre la douleur chronique pendant des années, les traitements d\'acupuncture de Dr. Chen ont changé ma vie. Je me sens enfin comme moi-même à nouveau!',
          name: 'Jennifer M.',
          service: 'Acupuncture'
        },
        {
          text: 'Les traitements d\'acu-lifting m\'ont donné des résultats visibles sans aucune procédure invasive. Ma peau a l\'air et se sent incroyable!',
          name: 'Michael T.',
          service: 'Acu-lifting'
        },
        {
          text: 'La thérapie de relaxation coréenne est le moyen parfait de se détendre après une semaine stressante. Dr. Chen crée un environnement si paisible et guérisseur.',
          name: 'Lisa K.',
          service: 'Relaxation Coréenne'
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: 'Réserver Votre Rendez-vous',
      subtitle: 'Sélectionnez votre service, date et heure préférés. Nous sommes impatients de soutenir votre parcours de bien-être.',
      form: {
        selectService: 'Sélectionner un Service',
        chooseService: 'Choisir un service',
        firstConsultation: 'C\'est ma première consultation (formulaire d\'admission supplémentaire requis)',
        fullName: 'Nom Complet',
        email: 'Email',
        phone: 'Numéro de Téléphone',
        reasonForConsultation: 'Raison de la Consultation',
        reasonPlaceholder: 'Veuillez décrire votre préoccupation principale ou raison de chercher un traitement d\'acupuncture...',
        selectDate: 'Sélectionner une Date',
        selectTime: 'Sélectionner un Créneau Horaire',
        homeCare: 'Soins à Domicile',
        homeCareInfo: 'Disponible les samedis, des frais supplémentaires peuvent s\'appliquer selon l\'emplacement. Contactez-moi via WhatsApp ou email pour plus d\'informations',
        continueToIntake: 'Continuer vers le Formulaire d\'Admission',
        confirmAppointment: 'Confirmer le Rendez-vous',
        namePlaceholder: 'Jean Dupont',
        emailPlaceholder: 'jean@exemple.com',
        phonePlaceholder: '06 12 34 56 78'
      },
      messages: {
        selectDateTime: 'Veuillez sélectionner une date, une heure et un service',
        bookingSuccess: 'Rendez-vous réservé avec succès! Nous vous enverrons un email de confirmation sous peu.',
        consultationSuccess: 'Formulaire de première consultation soumis avec succès! Nous vous contacterons sous peu.'
      }
    },
    
    // First Consultation Form
    consultation: {
      title: 'Formulaire d\'Admission Première Consultation',
      patientInfo: 'Informations Patient',
      majorComplaint: 'Plainte Principale',
      medicalHistory: 'Antécédents Médicaux',
      conditionsSurgeries: 'Conditions Médicales & Chirurgies',
      allergies: 'Allergies',
      occupational: 'Préoccupations Professionnelles',
      medications: 'Médicaments Actuels',
      lifestyle: 'Style de Vie',
      femalesOnly: 'Informations Santé Féminine',
      
      fields: {
        dob: 'Date de Naissance',
        gender: 'Genre',
        male: 'Homme',
        female: 'Femme',
        other: 'Autre',
        maritalStatus: 'État Civil',
        single: 'Célibataire',
        married: 'Marié(e)',
        divorced: 'Divorcé(e)',
        homeAddress: 'Adresse Domicile',
        phoneHome: 'Téléphone Domicile',
        phoneCell: 'Téléphone Portable',
        occupation: 'Profession',
        primaryDoctor: 'Médecin Traitant',
        specialty: 'Spécialité',
        emergencyContact: 'Nom Contact d\'Urgence',
        emergencyPhone: 'Téléphone Contact d\'Urgence',
        insurance: 'Compagnie d\'Assurance',
        policyNumber: 'Numéro de Police',
        
        complaintDesc: 'Veuillez décrire votre préoccupation principale',
        severity: 'Gravité',
        severe: 'Sévère',
        moderate: 'Modéré',
        slight: 'Léger',
        
        selectAll: 'Sélectionner tout ce qui s\'applique:',
        year: 'Année',
        condition: 'Condition / Chirurgie',
        allergiesDesc: 'Médicaments, Saisonnières, Alimentaires, Environnementales',
        
        stress: 'Stress',
        heavyTyping: 'Frappe Intensive/Utilisation Ordinateur',
        hazardous: 'Substances Dangereuses',
        heavyLifting: 'Port de Charges Lourdes',
        otherSpecify: 'Veuillez préciser',
        
        prescriptionName: 'Nom du Médicament',
        purpose: 'But',
        howLong: 'Depuis Combien de Temps',
        dose: 'Dose / Fréquence',
        lastDose: 'Dernière Dose',
        
        tobacco: 'Usage du Tabac',
        alcohol: 'Consommation d\'Alcool',
        exercise: 'Fréquence d\'Exercice',
        yes: 'Oui',
        no: 'Non',
        regular: 'Régulier',
        occasional: 'Occasionnel',
        none: 'Aucun',
        
        pregnant: 'Actuellement Enceinte',
        lastPeriod: 'Dernières Règles',
        numPregnancies: 'Nombre de Grossesses',
        numMiscarriages: 'Nombre de Fausses Couches',
        birthControl: 'Méthode de Contraception',
        menstrualCycle: 'Détails du Cycle Menstruel',
        pms: 'SPM (Syndrome Prémenstruel)',
        menopause: 'Symptômes de Ménopause',
        
        cancellationPolicy: 'Politique d\'Annulation: Je reconnais que je donnerai un préavis d\'au moins 24 heures d\'annulation pour éviter des frais pour la séance. C\'est une courtoisie envers les autres patients qui pourraient avoir besoin de ce créneau. J\'appellerai si je prévois d\'avoir plus de 10 minutes de retard à mon rendez-vous.',
        
        addCondition: '+ Ajouter une Autre Condition',
        addMedication: '+ Ajouter un Autre Médicament',
        cancel: 'Annuler',
        submit: 'Soumettre le Formulaire'
      }
    },
    

    // Contact Section
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Prenez contact avec nous. Nous sommes là pour répondre à vos questions et vous accompagner dans votre parcours de bien-être.',
      getInTouch: 'Contact',
      address: 'Adresse',
      phone: 'Téléphone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      officeHours: 'Horaires d\'ouverture',
      hoursWeekday: 'Lundi - Vendredi:',
      hoursWeekdayTime: '10h00 - 17h00',
      hoursWeekend: 'Samedi et dimanche:',
      hoursWeekendTime: 'Fermé',
      mapTitle: 'Nous trouver'
    },


    // First Consultation Form
    firstConsultation: {
      title: 'Formulaire d\'admission première consultation',
      subtitle: 'Veuillez remplir ce formulaire pour nous aider à vous fournir les meilleurs soins. Vous n\'êtes pas obligé de répondre à TOUTES les questions, mais cela aide à réduire le temps passé lors de la première consultation.',
      patientInfo: {
        title: 'Informations patient',
        dob: 'Date de naissance',
        gender: 'Sexe',
        male: 'Homme',
        female: 'Femme',
        other: 'Autre',
        maritalStatus: 'État civil',
        single: 'Célibataire',
        married: 'Marié(e)',
        divorced: 'Divorcé(e)',
        homeAddress: 'Adresse',
        phoneHome: 'Téléphone fixe',
        phoneCell: 'Téléphone portable',
        occupation: 'Profession'
      },
      majorComplaint: {
        title: 'Motif principal de consultation',
        describe: 'Veuillez décrire votre préoccupation principale',
        intensity: 'Intensité',
        severe: 'Sévère',
        moderate: 'Modérée',
        slight: 'Légère'
      },
      pastMedicalHistory: {
        title: 'Antécédents médicaux',
        checkAll: 'Cochez tout ce qui s\'applique',
        options: {
          'AIDS': 'SIDA',
          'Anxiety Attacks': 'Crises d\'angoisse',
          'Asthma': 'Asthme',
          'Autoimmune Disease': 'Maladie auto-immune',
          'Birth Defects': 'Malformations congénitales',
          'Bladder Infections': 'Infections urinaires',
          'Blood Disorders': 'Troubles sanguins',
          'Breast Tumor or Cancer': 'Tumeur ou cancer du sein',
          'Bronchitis': 'Bronchite',
          'Cancer': 'Cancer',
          'Cirrhosis': 'Cirrhose',
          'Connective Tissue Disorders': 'Troubles du tissu conjonctif',
          'Diabetes': 'Diabète',
          'Epilepsy': 'Épilepsie',
          'Gallstones': 'Calculs biliaires',
          'Gastric/Duodenal Ulcers': 'Ulcères gastriques/duodénaux',
          'German Measles': 'Rubéole',
          'Heart Attack': 'Crise cardiaque',
          'Heart Disease': 'Maladie cardiaque',
          'Heart Murmur': 'Souffle cardiaque',
          'Hepatitis': 'Hépatite',
          'High Blood Pressure': 'Hypertension artérielle',
          'Intestinal Bleeding': 'Saignements intestinaux',
          'Kidney Infection': 'Infection rénale',
          'Kidney Stones': 'Calculs rénaux',
          'Lupus': 'Lupus',
          'Neurologic Disorders': 'Troubles neurologiques',
          'Panic Attack': 'Crise de panique',
          'Paralysis': 'Paralysie',
          'Rheumatoid Arthritis': 'Polyarthrite rhumatoïde',
          'Seizures': 'Convulsions',
          'Thyroid Problems': 'Problèmes de thyroïde',
          'Tuberculosis': 'Tuberculose',
          'Varicose Veins': 'Varices'
        }
      },
      medicalConditions: {
        title: 'Conditions médicales et chirurgies',
        addCondition: '+ Ajouter une autre condition',
        year: 'Année',
        yearPlaceholder: '2020',
        description: 'Description',
        descriptionPlaceholder: 'Décrivez la condition ou la chirurgie'
      },
      allergies: {
        title: 'Allergies',
        label: 'Médicaments, saisonnières, alimentaires, environnementales',
        placeholder: 'Listez toutes les allergies...'
      },
      occupationalConcerns: {
        title: 'Préoccupations professionnelles',
        specify: 'Veuillez préciser',
        options: {
          'Stress': 'Stress',
          'Heavy Typing/Computer Use': 'Saisie/utilisation intensive de l\'ordinateur',
          'Hazardous Substances': 'Substances dangereuses',
          'Heavy Lifting': 'Port de charges lourdes',
          'Other': 'Autre'
        }
      },
      currentMedications: {
        title: 'Médicaments actuels',
        addMedication: '+ Ajouter un autre médicament',
        name: 'Nom du médicament',
        purpose: 'À quoi sert-il?',
        duration: 'Depuis combien de temps?',
        durationPlaceholder: '6 mois',
        dosage: 'Dosage',
        dosagePlaceholder: '10mg par jour',
        lastDose: 'Dernière prise'
      },
      lifestyle: {
        title: 'Mode de vie',
        tobacco: 'Consommez-vous du tabac?',
        alcohol: 'Consommez-vous de l\'alcool?',
        exercise: 'Exercice',
        yes: 'Oui',
        no: 'Non',
        regular: 'Régulier',
        occasional: 'Occasionnel',
        none: 'Aucun'
      },
      femaleHealth: {
        title: 'Informations santé féminine',
        pregnant: 'Êtes-vous enceinte?',
        lastPeriod: 'Dernières règles',
        numPregnancies: 'Nombre de grossesses',
        numMiscarriages: 'Nombre de fausses couches',
        birthControl: 'Méthode de contraception',
        menstrualCycle: 'Détails du cycle menstruel',
        pms: 'Symptômes prémenstruels?',
        lastPapTest: 'Dernier test PAP',
        ageStoppedPeriods: 'Âge d\'arrêt des règles',
        ageStoppedPlaceholder: 'Si applicable',
        menopauseSymptoms: 'Symptômes de ménopause',
        menopausePlaceholder: 'Si applicable, décrivez les symptômes de ménopause'
      },
      buttons: {
        cancel: 'Annuler',
        submit: 'Soumettre le formulaire'
      }
    },

    // Footer
    footer: {
      tagline: 'Services de Médecine Traditionnelle Chinoise et de bien-être holistique dédiés à votre santé et équilibre.',
      contact: 'Contactez-nous',
      hours: 'Heures d\'Ouverture',
      mondayFriday: 'Lundi - Vendredi',
      saturday: 'Samedi',
      sundayClosed: 'Dimanche - Fermé',
      copyright: '© {year} Tranquil Acupuncture. Tous droits réservés.'
    },
    
    // Common
    common: {
      minutes: 'minutes',
      benefits: 'Avantages:',
      required: '*'
    }
  },
  
  es: {
    // Navigation
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      about: 'Acerca de',
      testimonials: 'Testimonios',
      contact: 'Contacto',
      bookAppointment: 'Reservar Cita'
    },
    
    // Hero Section
    hero: {
      title: 'Restaura el Equilibrio.\nAbraza el Bienestar.',
      subtitle: 'Experimenta el poder curativo de la Medicina Tradicional China con acupuntura personalizada, rejuvenecimiento facial y terapias de relajación diseñadas para tu bienestar.',
      bookCTA: 'Reserva Tu Cita',
      exploreCTA: 'Explorar Servicios'
    },
    
    // Services Section
    services: {
      title: 'Nuestros Servicios',
      subtitle: 'Descubre nuestra gama de tratamientos de Medicina Tradicional China diseñados para restaurar el equilibrio y promover la curación natural.',
      learnMore: 'Saber más',
      acupuncture: {
        name: 'Acupuntura',
        shortDesc: 'Técnica de medicina tradicional china que utiliza agujas finas para restaurar el equilibrio y promover la curación natural.',
        fullDesc: 'Nuestros tratamientos de acupuntura abordan una amplia gama de condiciones, incluyendo manejo del dolor, alivio del estrés, problemas digestivos y bienestar general. Cada sesión se adapta a tus necesidades específicas.',
        benefits: [
          'Alivio y manejo del dolor',
          'Reducción del estrés y ansiedad',
          'Mejora de la calidad del sueño',
          'Función inmune mejorada',
          'Apoyo a la salud digestiva'
        ]
      },
      aculifting: {
        name: 'Acu-lifting',
        shortDesc: 'Rejuvenecimiento facial natural utilizando técnicas de masaje y acupuntura para mejorar el tono de la piel y reducir los signos del envejecimiento.',
        fullDesc: 'El acu-lifting es una alternativa natural y no invasiva a los procedimientos cosméticos. Al estimular la producción de colágeno y mejorar la circulación, este tratamiento ayuda a reducir las líneas finas, mejorar el tono de la piel y restaurar un brillo juvenil.',
        benefits: [
          'Reduce líneas finas y arrugas',
          'Mejora la elasticidad de la piel',
          'Mejora el tono muscular facial',
          'Promueve la producción natural de colágeno',
          'Crea un brillo saludable y radiante'
        ]
      },
      koreanRelaxation: {
        name: 'Relajación Coreana',
        shortDesc: 'Enfoque terapéutico que combina técnicas coreanas tradicionales con estimulación de puntos de acupuntura a través de acupresión.',
        fullDesc: 'Experimenta una relajación profunda y curación con nuestra terapia de relajación coreana. Este tratamiento suave pero efectivo combina técnicas de masaje coreano tradicionales con acupresión para liberar tensiones y restaurar el equilibrio.',
        benefits: [
          'Relajación muscular profunda',
          'Alivio del estrés y tensión',
          'Mejora de la circulación',
          'Flujo de energía mejorado',
          'Claridad mental y calma'
        ]
      }
    },
    
    
    // Service Detail Pages
    serviceDetails: {
      duration: 'Duración',
      aboutTreatment: 'Acerca de este tratamiento',
      therapeuticIndications: 'Indicaciones terapéuticas:',
      benefits: 'Beneficios:',
      whatToExpect: 'Qué esperar',
      readyToBook: '¿Listo para reservar tu cita?',
      bookingCTA: 'Da el primer paso hacia una mejor salud y bienestar. Programa tu sesión de',
      sessionToday: 'hoy.',
      
      acupuncture: {
        aboutText: 'Nuestros tratamientos de acupuntura abordan una amplia gama de condiciones, incluyendo manejo del dolor, alivio del estrés, problemas digestivos y bienestar general. Cada sesión se adapta a tus necesidades específicas.',
        indications: [
          'Dolor crónico: dolor lumbar, dolores de cabeza, osteoartritis, etc.',
          'Estrés, ansiedad, insomnio crónico',
          'Problemas digestivos, náuseas, gastritis, etc.',
          'Problemas relacionados con deportes: ciática, codo de tenista/golfista, dolor de hombro/rodilla, etc.',
          'Efectos secundarios de medicación a largo plazo'
        ],
        expectSteps: [
          { title: 'Consulta inicial:', desc: 'Discutiremos tus preocupaciones de salud y objetivos de tratamiento' },
          { title: 'Colocación de agujas:', desc: 'Agujas finas y estériles se insertan suavemente en puntos específicos' },
          { title: 'Relajación:', desc: 'Descansa cómodamente durante 15-20 minutos mientras el tratamiento actúa' },
          { title: 'Seguimiento:', desc: 'Discute tu experiencia y planifica los próximos pasos' }
        ],
        expectIntro: 'Durante tu sesión de acupuntura, experimentarás:'
      },
      
      aculifting: {
        aboutText: 'El acu-lifting es una alternativa natural y no invasiva a los procedimientos cosméticos. Al estimular la producción de colágeno y mejorar la circulación, este tratamiento ayuda a reducir las líneas finas, mejorar el tono de la piel y restaurar un brillo juvenil.',
        benefitsList: [
          'Reduce líneas finas y arrugas',
          'Mejora la elasticidad de la piel',
          'Mejora el tono muscular facial',
          'Promueve la producción natural de colágeno',
          'Crea un brillo saludable y radiante'
        ],
        expectSteps: [
          { title: 'Evaluación facial:', desc: 'Análisis de tus preocupaciones de piel y estructura facial' },
          { title: 'Masaje facial:', desc: 'Masaje suave para preparar la piel y mejorar la circulación' },
          { title: 'Tratamiento de acupuntura:', desc: 'Colocación estratégica de agujas en puntos faciales' },
          { title: 'Consejos de cuidado posterior:', desc: 'Consejos para mantener y mejorar tus resultados' }
        ],
        expectIntro: 'Durante tu sesión de acu-lifting, experimentarás:'
      },
      
      koreanRelaxation: {
        aboutText: 'Experimenta una relajación profunda y curación con nuestra terapia de relajación coreana. Este tratamiento suave pero efectivo combina técnicas coreanas tradicionales con acupresión para liberar tensiones y restaurar el equilibrio.',
        benefitsList: [
          'Relajación muscular profunda',
          'Alivio del estrés y tensión',
          'Mejora de la circulación',
          'Flujo de energía mejorado',
          'Claridad mental y calma'
        ],
        expectSteps: [
          { title: 'Configuración cómoda:', desc: 'Ponte cómodo en un ambiente tranquilo y relajante' },
          { title: 'Técnicas tradicionales:', desc: 'Experimenta métodos de masaje coreano auténticos' },
          { title: 'Acupresión:', desc: 'Puntos de presión dirigidos para liberar la tensión' },
          { title: 'Relajación completa:', desc: 'Sal sintiéndote renovado y equilibrado' }
        ],
        expectIntro: 'Durante tu sesión de relajación coreana, experimentarás:'
      }
    },

    // About Section
    about: {
      title: 'Conoce a tu practicante',
      subtitle: 'Dedicado a tu salud y bienestar a través de la medicina tradicional china',
      name: 'Jeremy de Sainte Marie',
      practitionerTitle: 'Acupunturista certificado y practicante de medicina tradicional china',
      bio: 'Con casi 10 años de experiencia en medicina tradicional china, Jeremy se dedica a ayudar a los pacientes a lograr una salud óptima a través de enfoques naturales y holísticos. Combina la sabiduría antigua con técnicas modernas para brindar atención personalizada a cada individuo.',
      credentialsTitle: 'Credenciales',
      credentials: [
        'Practicante certificado de medicina tradicional china - Certificado de 5 años - Institutos IMTC y EMC',
        'DNMTC - Diploma nacional francés'
      ]
    },
    
    // Testimonials Section
    testimonials: {
      title: 'Lo Que Dicen Nuestros Pacientes',
      subtitle: 'Lee sobre las experiencias de quienes han encontrado curación y bienestar con nosotros',
      items: [
        {
          text: 'Después de luchar contra el dolor crónico durante años, los tratamientos de acupuntura de la Dra. Chen han cambiado mi vida. ¡Finalmente me siento como yo mismo otra vez!',
          name: 'Jennifer M.',
          service: 'Acupuntura'
        },
        {
          text: 'Los tratamientos de acu-lifting me han dado resultados visibles sin ningún procedimiento invasivo. ¡Mi piel se ve y se siente increíble!',
          name: 'Michael T.',
          service: 'Acu-lifting'
        },
        {
          text: 'La terapia de relajación coreana es la manera perfecta de relajarse después de una semana estresante. La Dra. Chen crea un ambiente tan pacífico y curativo.',
          name: 'Lisa K.',
          service: 'Relajación Coreana'
        }
      ]
    },
    
    // Booking Section
    booking: {
      title: 'Reserva Tu Cita',
      subtitle: 'Selecciona tu servicio, fecha y hora preferidos. Esperamos apoyar tu viaje de bienestar.',
      form: {
        selectService: 'Seleccionar Servicio',
        chooseService: 'Elige un servicio',
        firstConsultation: 'Esta es mi primera consulta (se requiere formulario de admisión adicional)',
        fullName: 'Nombre Completo',
        email: 'Correo Electrónico',
        phone: 'Número de Teléfono',
        reasonForConsultation: 'Motivo de Consulta',
        reasonPlaceholder: 'Por favor describe tu preocupación principal o motivo para buscar tratamiento de acupuntura...',
        selectDate: 'Seleccionar Fecha',
        selectTime: 'Seleccionar Horario',
        homeCare: 'Cuidado a Domicilio',
        homeCareInfo: 'Disponible los sábados, pueden aplicarse tarifas adicionales según la ubicación. Contáctame vía WhatsApp o email para más información',
        continueToIntake: 'Continuar al Formulario de Admisión',
        confirmAppointment: 'Confirmar Cita',
        namePlaceholder: 'Juan Pérez',
        emailPlaceholder: 'juan@ejemplo.com',
        phonePlaceholder: '(555) 123-4567'
      },
      messages: {
        selectDateTime: 'Por favor selecciona una fecha, hora y servicio',
        bookingSuccess: '¡Cita reservada con éxito! Te enviaremos un correo de confirmación en breve.',
        consultationSuccess: '¡Formulario de primera consulta enviado con éxito! Te contactaremos en breve.',
        slotConflict: 'Este horario acaba de ser reservado. Por favor elige otro.'
      }
    },
    
    // First Consultation Form
    consultation: {
      title: 'Formulario de Admisión Primera Consulta',
      patientInfo: 'Información del Paciente',
      majorComplaint: 'Queja Principal',
      medicalHistory: 'Historial Médico',
      conditionsSurgeries: 'Condiciones Médicas y Cirugías',
      allergies: 'Alergias',
      occupational: 'Preocupaciones Ocupacionales',
      medications: 'Medicamentos Actuales',
      lifestyle: 'Estilo de Vida',
      femalesOnly: 'Información de Salud Femenina',
      
      fields: {
        dob: 'Fecha de Nacimiento',
        gender: 'Género',
        male: 'Masculino',
        female: 'Femenino',
        other: 'Otro',
        maritalStatus: 'Estado Civil',
        single: 'Soltero/a',
        married: 'Casado/a',
        divorced: 'Divorciado/a',
        homeAddress: 'Dirección del Hogar',
        phoneHome: 'Teléfono del Hogar',
        phoneCell: 'Teléfono Celular',
        occupation: 'Ocupación',
        primaryDoctor: 'Médico de Cabecera',
        specialty: 'Especialidad',
        emergencyContact: 'Nombre de Contacto de Emergencia',
        emergencyPhone: 'Teléfono de Contacto de Emergencia',
        insurance: 'Compañía de Seguros',
        policyNumber: 'Número de Póliza',
        
        complaintDesc: 'Por favor describe tu preocupación principal',
        severity: 'Severidad',
        severe: 'Severo',
        moderate: 'Moderado',
        slight: 'Leve',
        
        selectAll: 'Selecciona todos los que apliquen:',
        year: 'Año',
        condition: 'Condición / Cirugía',
        allergiesDesc: 'Medicamentos, Estacionales, Alimentarias, Ambientales',
        
        stress: 'Estrés',
        heavyTyping: 'Mecanografía Intensa/Uso de Computadora',
        hazardous: 'Sustancias Peligrosas',
        heavyLifting: 'Levantamiento de Cargas Pesadas',
        otherSpecify: 'Por favor especifica',
        
        prescriptionName: 'Nombre del Medicamento',
        purpose: 'Propósito',
        howLong: 'Por Cuánto Tiempo',
        dose: 'Dosis / Frecuencia',
        lastDose: 'Última Dosis',
        
        tobacco: 'Uso de Tabaco',
        alcohol: 'Consumo de Alcohol',
        exercise: 'Frecuencia de Ejercicio',
        yes: 'Sí',
        no: 'No',
        regular: 'Regular',
        occasional: 'Ocasional',
        none: 'Ninguno',
        
        pregnant: 'Actualmente Embarazada',
        lastPeriod: 'Último Período',
        numPregnancies: 'Número de Embarazos',
        numMiscarriages: 'Número de Abortos',
        birthControl: 'Método Anticonceptivo',
        menstrualCycle: 'Detalles del Ciclo Menstrual',
        pms: 'SPM (Síndrome Premenstrual)',
        menopause: 'Síntomas de Menopausia',
        
        cancellationPolicy: 'Política de Cancelación: Reconozco que daré un aviso de al menos 24 horas de cancelación para evitar un cargo por la sesión. Esta es una cortesía para otros pacientes que puedan necesitar ese horario. Llamaré si anticipo llegar más de 10 minutos tarde a mi cita.',
        
        addCondition: '+ Agregar Otra Condición',
        addMedication: '+ Agregar Otro Medicamento',
        cancel: 'Cancelar',
        submit: 'Enviar Formulario'
      }
    },

    // Contact Section
    contact: {
      title: 'Contáctanos',
      subtitle: 'Ponte en contacto con nosotros. Estamos aquí para responder tus preguntas y ayudarte en tu camino hacia el bienestar.',
      getInTouch: 'Ponte en contacto',
      address: 'Dirección',
      phone: 'Teléfono',
      whatsapp: 'WhatsApp',
      email: 'Correo electrónico',
      officeHours: 'Horario de atención',
      hoursWeekday: 'Lunes - Viernes:',
      hoursWeekdayTime: '10:00 - 17:00',
      hoursWeekend: 'Sábado y domingo:',
      hoursWeekendTime: 'Cerrado',
      mapTitle: 'Encuéntranos'
    },
    

    // First Consultation Form
    firstConsultation: {
      title: 'Formulario de admisión primera consulta',
      subtitle: 'Por favor completa este formulario para ayudarnos a brindarte el mejor cuidado. No tienes que responder TODAS las preguntas, pero hacerlo ayuda a reducir el tiempo de la primera consulta.',
      patientInfo: {
        title: 'Información del paciente',
        dob: 'Fecha de nacimiento',
        gender: 'Sexo',
        male: 'Hombre',
        female: 'Mujer',
        other: 'Otro',
        maritalStatus: 'Estado civil',
        single: 'Soltero/a',
        married: 'Casado/a',
        divorced: 'Divorciado/a',
        homeAddress: 'Dirección',
        phoneHome: 'Teléfono fijo',
        phoneCell: 'Teléfono móvil',
        occupation: 'Ocupación'
      },
      majorComplaint: {
        title: 'Motivo principal de consulta',
        describe: 'Por favor describe tu preocupación principal',
        intensity: 'Intensidad',
        severe: 'Severa',
        moderate: 'Moderada',
        slight: 'Leve'
      },
      pastMedicalHistory: {
        title: 'Historial médico',
        checkAll: 'Marca todo lo que aplique',
        options: {
          'AIDS': 'SIDA',
          'Anxiety Attacks': 'Ataques de ansiedad',
          'Asthma': 'Asma',
          'Autoimmune Disease': 'Enfermedad autoinmune',
          'Birth Defects': 'Defectos congénitos',
          'Bladder Infections': 'Infecciones de vejiga',
          'Blood Disorders': 'Trastornos sanguíneos',
          'Breast Tumor or Cancer': 'Tumor o cáncer de mama',
          'Bronchitis': 'Bronquitis',
          'Cancer': 'Cáncer',
          'Cirrhosis': 'Cirrosis',
          'Connective Tissue Disorders': 'Trastornos del tejido conectivo',
          'Diabetes': 'Diabetes',
          'Epilepsy': 'Epilepsia',
          'Gallstones': 'Cálculos biliares',
          'Gastric/Duodenal Ulcers': 'Úlceras gástricas/duodenales',
          'German Measles': 'Rubéola',
          'Heart Attack': 'Ataque cardíaco',
          'Heart Disease': 'Enfermedad cardíaca',
          'Heart Murmur': 'Soplo cardíaco',
          'Hepatitis': 'Hepatitis',
          'High Blood Pressure': 'Presión arterial alta',
          'Intestinal Bleeding': 'Sangrado intestinal',
          'Kidney Infection': 'Infección renal',
          'Kidney Stones': 'Cálculos renales',
          'Lupus': 'Lupus',
          'Neurologic Disorders': 'Trastornos neurológicos',
          'Panic Attack': 'Ataque de pánico',
          'Paralysis': 'Parálisis',
          'Rheumatoid Arthritis': 'Artritis reumatoide',
          'Seizures': 'Convulsiones',
          'Thyroid Problems': 'Problemas de tiroides',
          'Tuberculosis': 'Tuberculosis',
          'Varicose Veins': 'Várices'
        }
      },
      medicalConditions: {
        title: 'Condiciones médicas y cirugías',
        addCondition: '+ Agregar otra condición',
        year: 'Año',
        yearPlaceholder: '2020',
        description: 'Descripción',
        descriptionPlaceholder: 'Describe la condición o cirugía'
      },
      allergies: {
        title: 'Alergias',
        label: 'Medicamentos, estacionales, alimentarias, ambientales',
        placeholder: 'Lista todas las alergias...'
      },
      occupationalConcerns: {
        title: 'Preocupaciones laborales',
        specify: 'Por favor especifica',
        options: {
          'Stress': 'Estrés',
          'Heavy Typing/Computer Use': 'Escritura/uso intensivo del ordenador',
          'Hazardous Substances': 'Sustancias peligrosas',
          'Heavy Lifting': 'Levantamiento de cargas pesadas',
          'Other': 'Otro'
        }
      },
      currentMedications: {
        title: 'Medicamentos actuales',
        addMedication: '+ Agregar otro medicamento',
        name: 'Nombre del medicamento',
        purpose: '¿Para qué es?',
        duration: '¿Por cuánto tiempo?',
        durationPlaceholder: '6 meses',
        dosage: 'Dosis',
        dosagePlaceholder: '10mg diario',
        lastDose: 'Última dosis'
      },
      lifestyle: {
        title: 'Estilo de vida',
        tobacco: '¿Consumes tabaco?',
        alcohol: '¿Consumes alcohol?',
        exercise: 'Ejercicio',
        yes: 'Sí',
        no: 'No',
        regular: 'Regular',
        occasional: 'Ocasional',
        none: 'Ninguno'
      },
      femaleHealth: {
        title: 'Información de salud femenina',
        pregnant: '¿Estás embarazada?',
        lastPeriod: 'Última menstruación',
        numPregnancies: 'Número de embarazos',
        numMiscarriages: 'Número de abortos espontáneos',
        birthControl: 'Método anticonceptivo',
        menstrualCycle: 'Detalles del ciclo menstrual',
        pms: '¿Síntomas premenstruales?',
        lastPapTest: 'Última prueba de Papanicolaou',
        ageStoppedPeriods: 'Edad de cese de menstruación',
        ageStoppedPlaceholder: 'Si aplica',
        menopauseSymptoms: 'Síntomas de menopausia',
        menopausePlaceholder: 'Si aplica, describe los síntomas de menopausia'
      },
      buttons: {
        cancel: 'Cancelar',
        submit: 'Enviar formulario'
      }
    },

    // Footer
    footer: {
      tagline: 'Servicios de Medicina Tradicional China y bienestar holístico dedicados a tu salud y equilibrio.',
      contact: 'Contáctanos',
      hours: 'Horario de Oficina',
      mondayFriday: 'Lunes - Viernes',
      saturday: 'Sábado',
      sundayClosed: 'Domingo - Cerrado',
      copyright: '© {year} Tranquil Acupuncture. Todos los derechos reservados.'
    },
    
    // Common
    common: {
      minutes: 'minutos',
      benefits: 'Beneficios:',
      required: '*'
    }
  }
};

